<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <div class="relative">
        <input :type="type" :id="id" ref="input" v-bind="{ ...$attrs, class: null }" class="form-input pr-10" :class="{ error: error }" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
        <font-awesome-icon v-if="!showPassword" class="cursor-pointer absolute bottom-3 right-3" icon="fa-eye" @click="toggleShow" />
        <font-awesome-icon v-if="showPassword" class="cursor-pointer absolute bottom-3 right-3" icon="fa-eye-slash" @click="toggleShow" />
    </div>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
  <div v-if="showPasswordRequirements" class="text-sm mt-2">
    <div>Como criar uma senha segura?</div>
    <div class="mt-2" :class="{'text-red-700': !passwordRequirements.length, 'text-green-700': passwordRequirements.length}"><font-awesome-icon v-if="!passwordRequirements.length" icon="fa-circle-minus" class="mr-1" /><font-awesome-icon v-if="passwordRequirements.length" icon="fa-circle-check" class="mr-1" /> Um mínimo de 8 caracteres</div>
    <div :class="{'text-red-700': !passwordRequirements.upper, 'text-green-700': passwordRequirements.upper}"><font-awesome-icon v-if="!passwordRequirements.upper" icon="fa-circle-minus" class="mr-1" /><font-awesome-icon v-if="passwordRequirements.upper" icon="fa-circle-check" class="mr-1" /> Pelo menos um caractere maiúsculo</div>
    <div :class="{'text-red-700': !passwordRequirements.lower, 'text-green-700': passwordRequirements.lower}"><font-awesome-icon v-if="!passwordRequirements.lower" icon="fa-circle-minus" class="mr-1" /><font-awesome-icon v-if="passwordRequirements.lower" icon="fa-circle-check" class="mr-1" /> Pelo menos um caractere minúsculo</div>
    <div :class="{'text-red-700': !passwordRequirements.number, 'text-green-700': passwordRequirements.number}"><font-awesome-icon v-if="!passwordRequirements.number" icon="fa-circle-minus" class="mr-1" /><font-awesome-icon v-if="passwordRequirements.number" icon="fa-circle-check" class="mr-1" /> Pelo menos um número</div>
    <div :class="{'text-red-700': !passwordRequirements.special, 'text-green-700': passwordRequirements.special}"><font-awesome-icon v-if="!passwordRequirements.special" icon="fa-circle-minus" class="mr-1" /><font-awesome-icon v-if="passwordRequirements.special" icon="fa-circle-check" class="mr-1" /> Pelo menos um caractere especial (!@#$%&*)</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  data() {
    return {
      showPassword: false,
      passwordRequirements: {
        length: false,
        upper: false,
        lower: false,
        number: false,
        special: false,
      },
    };
  },
  props: {
    id: {
      default() {
        return `text-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    modelValue: String,
    showPasswordRequirements: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    type: function() {
      return this.showPassword ? 'text' : 'password';
    },
  },
  emits: [
    'update:modelValue',
    'updatePasswordStatus'
  ],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    }
  },
  watch: {
    modelValue: function(newValue, oldValue) {
      this.passwordRequirements = {
        length: false,
        upper: false,
        lower: false,
        number: false,
        special: false,
      };

      if(this.modelValue.length) {
        if(this.modelValue.length > 8) {
          this.passwordRequirements.length = true;
        }
        if(this.modelValue.match(/[A-Z]/)) {
          this.passwordRequirements.upper = true;
        }
        if(this.modelValue.match(/[a-z]/)) {
          this.passwordRequirements.lower = true;
        }
        if(this.modelValue.match(/[0-9]/)) {
          this.passwordRequirements.number = true;
        }
        if(this.modelValue.match(/[!@#$%&*]/)) {
          this.passwordRequirements.special = true;
        }
      }
      let passwordIsValid = Object.values(this.passwordRequirements).every(requiriment => requiriment);
      this.$emit('updatePasswordStatus', passwordIsValid);
    }
  }
}
</script>
